<template>
  <div>
      menu2-1
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {

    };
  },
  created() {},
  mounted() {},
  methods: {

  },
  computed: {},
  watch: {},
};
</script>

<style scoped>

</style>
